import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryTimerSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <g clipPath="url(#clip0_6525_104596)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 9C14.6155 9 13.2622 9.41054 12.111 10.1797C10.9599 10.9489 10.0627 12.0421 9.53285 13.3212C9.00303 14.6003 8.86441 16.0078 9.13451 17.3656C9.4046 18.7235 10.0713 19.9708 11.0503 20.9497C12.0292 21.9287 13.2765 22.5954 14.6344 22.8655C15.9922 23.1356 17.3997 22.997 18.6788 22.4672C19.9579 21.9373 21.0511 21.0401 21.8203 19.889C22.5895 18.7378 23 17.3845 23 16C23 14.1435 22.2625 12.363 20.9497 11.0503C19.637 9.7375 17.8565 9 16 9ZM19.15 17.4H16.006C15.7759 17.3937 15.557 17.2995 15.3943 17.1367C15.2315 16.974 15.1373 16.7551 15.131 16.525V12.509C15.131 12.2769 15.2232 12.0544 15.3873 11.8903C15.5514 11.7262 15.7739 11.634 16.006 11.634C16.2381 11.634 16.4606 11.7262 16.6247 11.8903C16.7888 12.0544 16.881 12.2769 16.881 12.509V15.646H19.15C19.3821 15.646 19.6046 15.7382 19.7687 15.9023C19.9328 16.0664 20.025 16.2889 20.025 16.521C20.025 16.7531 19.9328 16.9756 19.7687 17.1397C19.6046 17.3038 19.3821 17.396 19.15 17.396V17.4Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_6525_104596">
            <rect width="14" height="14" fill="white" transform="translate(9 9)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default TaskHistoryTimerSVG;
